var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"wd-100p",style:(`height: ${_vm.getScrollHeight()} border: 0`),attrs:{"src":_vm.task.taskEn,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }